/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venue_CountInputs */

const th_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนาม`)
};

const en_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venues`)
};

const ja_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場`)
};

const zh_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场馆`)
};

const es_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabellones`)
};

const pt_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásios`)
};

const id_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const fr_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salles`)
};

const tl_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga venue`)
};

const vi_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa điểm`)
};

const ko_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장`)
};

const de_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallen`)
};

const ru_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадки`)
};

const tr_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salonlar`)
};

const it_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianti`)
};

const pl_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hale`)
};

const uk_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчики`)
};

const hi_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थल`)
};

const ar_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصالات`)
};

const ms_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat`)
};

const bn_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠ`)
};

const zh_tw2_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const zh_hk2_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場館`)
};

const ur_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقامات`)
};

const fa_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن‌ها`)
};

const sw_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumbi`)
};

const nl_venue_count = /** @type {(inputs: Venue_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalen`)
};

/**
* | output |
* | --- |
* | "Venues" |
*
* @param {Venue_CountInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const venue_count = /** @type {((inputs?: Venue_CountInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venue_CountInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_venue_count(inputs)
	if (locale === "ja") return ja_venue_count(inputs)
	if (locale === "zh") return zh_venue_count(inputs)
	if (locale === "es") return es_venue_count(inputs)
	if (locale === "pt") return pt_venue_count(inputs)
	if (locale === "id") return id_venue_count(inputs)
	if (locale === "fr") return fr_venue_count(inputs)
	if (locale === "tl") return tl_venue_count(inputs)
	if (locale === "vi") return vi_venue_count(inputs)
	if (locale === "ko") return ko_venue_count(inputs)
	if (locale === "de") return de_venue_count(inputs)
	if (locale === "ru") return ru_venue_count(inputs)
	if (locale === "tr") return tr_venue_count(inputs)
	if (locale === "it") return it_venue_count(inputs)
	if (locale === "pl") return pl_venue_count(inputs)
	if (locale === "uk") return uk_venue_count(inputs)
	if (locale === "hi") return hi_venue_count(inputs)
	if (locale === "ar") return ar_venue_count(inputs)
	if (locale === "ms") return ms_venue_count(inputs)
	if (locale === "bn") return bn_venue_count(inputs)
	if (locale === "zh-TW") return zh_tw2_venue_count(inputs)
	if (locale === "zh-HK") return zh_hk2_venue_count(inputs)
	if (locale === "ur") return ur_venue_count(inputs)
	if (locale === "fa") return fa_venue_count(inputs)
	if (locale === "sw") return sw_venue_count(inputs)
	if (locale === "nl") return nl_venue_count(inputs)
	return en_venue_count(inputs)
});